export enum ProfaxType {
    Email = "email",
    MSV3 = "msv3",
    NONE = ""
}